// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:2XXBrq */\n.uX2sY{grid-gap:var(--audio-spacing-16);display:grid;gap:var(--audio-spacing-16);grid-template-columns:minmax(0,1fr)}.StiJv{font-size:var(--audio-font-size-20);font-weight:600;letter-spacing:normal;line-height:var(--audio-line-height-24);margin:0;text-transform:uppercase}.LeGsA{grid-gap:var(--audio-spacing-8);display:grid;gap:var(--audio-spacing-8);grid-template-columns:minmax(0,1fr);list-style:none;margin:0;padding:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": "uX2sY",
	"title": "StiJv",
	"list": "LeGsA"
};
export default ___CSS_LOADER_EXPORT___;
